// Content for legal and info pages (Terms, Privacy, Accessibility, Cookies, Sitemap)

export const legalPages = {
  terms: {
    title: 'Terms of Use',
    lastUpdated: 'March 2026',
    sections: [
      {
        heading: 'Acceptance of Terms',
        body: 'By accessing or using Learnwithinfobloom (“we”, “our”, “the platform”), you agree to be bound by these Terms of Use. If you do not agree, please do not use our services.',
      },
      {
        heading: 'Use of the Platform',
        body: 'You may use Learnwithinfobloom only for lawful purposes and in accordance with these terms. You agree not to misuse the platform, share account credentials, or redistribute course materials without permission.',
      },
      {
        heading: 'Accounts and Registration',
        body: 'You must provide accurate information when creating an account. You are responsible for keeping your password secure and for all activity under your account.',
      },
      {
        heading: 'Intellectual Property',
        body: 'All content on the platform—including courses, text, graphics, and software—is owned by Infobloom or its licensors. You may not copy, modify, or distribute this content without written permission.',
      },
      {
        heading: 'Contact',
        body: 'For questions about these terms, contact us through the Contact us link in the footer.',
      },
    ],
  },
  privacy: {
    title: 'Privacy Policy',
    lastUpdated: 'March 2026',
    sections: [
      {
        heading: 'Information We Collect',
        body: 'We collect information you provide when you register, enroll in courses, or contact us. This may include name, email, and learning progress. We also collect usage data to improve our platform.',
      },
      {
        heading: 'How We Use Your Information',
        body: 'We use your information to provide and improve our services, personalize your experience, send important updates about your courses, and comply with legal obligations.',
      },
      {
        heading: 'Sharing of Information',
        body: 'We do not sell your personal data. We may share information with service providers who assist us in operating the platform, under strict confidentiality agreements.',
      },
      {
        heading: 'Data Security',
        body: 'We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, or destruction.',
      },
      {
        heading: 'Your Rights',
        body: 'You may access, correct, or delete your personal data through your account settings or by contacting us. You may also opt out of marketing communications at any time.',
      },
    ],
  },
  accessibility: {
    title: 'Accessibility Statement',
    lastUpdated: 'March 2026',
    sections: [
      {
        heading: 'Our Commitment',
        body: 'Learnwithinfobloom is committed to ensuring digital accessibility for people with disabilities. We continually improve the user experience and apply relevant accessibility standards.',
      },
      {
        heading: 'Measures We Take',
        body: 'We aim to meet WCAG 2.1 Level AA where practicable. This includes providing text alternatives for images, keyboard navigation support, sufficient color contrast, and resizable text.',
      },
      {
        heading: 'Feedback',
        body: 'If you encounter an accessibility barrier on our platform, please contact us. We will work with you to provide the information or service you need.',
      },
      {
        heading: 'Contact',
        body: 'For accessibility-related requests or feedback, use the Contact us link in the footer or email us with “Accessibility” in the subject line.',
      },
    ],
  },
  cookies: {
    title: 'Cookie Settings & Policy',
    lastUpdated: 'March 2026',
    sections: [
      {
        heading: 'What Are Cookies',
        body: 'Cookies are small text files stored on your device when you visit our site. They help us remember your preferences, keep you signed in, and understand how you use the platform.',
      },
      {
        heading: 'Types of Cookies We Use',
        body: 'We use essential cookies (required for the site to work), functional cookies (e.g. language preference), and analytics cookies (to improve our services). You can control non-essential cookies below.',
      },
      {
        heading: 'Your Choices',
        body: 'You can change your cookie preferences at any time. Disabling certain cookies may affect some features of the platform. Essential cookies cannot be disabled.',
      },
      {
        heading: 'Cookie Settings',
        body: 'Essential: Always on. Analytics: Optional. Marketing: Optional. Update your choices and save below.',
      },
    ],
  },
  sitemap: {
    title: 'Sitemap',
    lastUpdated: 'March 2026',
    sections: [
      {
        heading: 'Main Pages',
        body: 'Home · Login · Sign up · My Learning · Profile · Certificates',
      },
      {
        heading: 'Learning',
        body: 'Browse courses · Course details · Start learning',
      },
      {
        heading: 'Legal & Info',
        body: 'Terms of Use · Privacy Policy · Accessibility Statement · Cookie settings · Sitemap (this page)',
      },
      {
        heading: 'Support',
        body: 'About us · Contact us · Blog · Careers',
      },
    ],
  },
};
